import { useAppContext } from "../../context/AppContext";
import InputWithLabel from "../InputWithLabel";
import CreditLimitDropDown from "./CreditLimitDropDown";
import BuyerInformation from "./BuyerInformation";

export type ApprovedFinance = {
  approved_finance_id: number;
  created_at: string;
  finance_partner_id: number;
  invoice_buyer_id: number;
  limit_request: string;
  payment_terms: string;
  term_conditions: number;
  uid: number;
};

export default function FundYourTransaction() {
  const { user } = useAppContext();

  return (
    <section>
      <div className="flex mt-4 gap-4">
        <InputWithLabel
          disabled={true}
          label={"Company Name"}
          defaultValue={user?.company_name}
        />
        <InputWithLabel
          disabled={true}
          label={"Registration Number"}
          defaultValue={user?.company_reg_number}
        />
        <InputWithLabel
          disabled={true}
          label={"Address"}
          defaultValue={`${user?.registered_addressLine1}, ${
            user?.registered_addressLine2
              ? user?.registered_addressLine2 + ","
              : ""
          } ${user?.registered_city}, ${user?.registered_state}, ${
            user?.registered_country
          }`}
        />
      </div>
      <div className="w-[260px]">
        <CreditLimitDropDown />
      </div>
      {/* <CreditLimitDropDown
        setSelectedFinancePartnerId={setSelectedFinancePartnerId}
        buyerData={buyerData}
      /> */}

      {/* <div className="py-5 border-b-2">
        <button
          type="button"
          className="h-[44px] px-2 text-[#0348B7] font-semibold border border-[#0348B7] rounded-lg"
          onClick={openRequestNewCreditLimitModal}
        >
          Request New Credit Limit
        </button>
      </div> */}
      <BuyerInformation
        openBuyerCompanyModal={function (): void {
          throw new Error("Function not implemented.");
        }}
        invoiceFactoringData={null}
      />
    </section>
  );
}
